import { makeThemeShadowsScale } from './utils/make-theme';
import { colors } from './colors';

const shadows = makeThemeShadowsScale({
  pressed: `inset 0 3px 5px ${colors.shadowSubtle}`,
  light: `0px 0px 3px ${colors.shadowSubtle}`,
});

export default shadows;
